var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table',{staticClass:"table-sm-font",attrs:{"data":_vm.dataset,"loading":_vm.loading,"buttons":_vm.buttons,"header":_vm.header,"responsive":true,"auto-update":false,"lang":_vm.lang,"paging":true,"actions":true},on:{"action":_vm.onAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }